import { stegaClean } from "@sanity/client/stega";

const SINGLE_STEGA_CHARS = "[\\u200B\\u200C\\u200D\\u2060\\u2061\\u2062\\u2063\\uFEFF]";
const PAIR_STEGA_CHARS = "\\uD834[\\uDD73-\\uDD7A]";

const STEGA_SEGMENT = `(?:${SINGLE_STEGA_CHARS}|${PAIR_STEGA_CHARS})+`;
const STEGA_PATTERN = new RegExp(STEGA_SEGMENT, "g");

export function stripStega(value: string): string;
export function stripStega<T extends string | null | undefined>(value: T): T;
export function stripStega(value: string | null | undefined): string | null | undefined {
  if (typeof value !== "string") {
    return value;
  }
  return stegaClean(value);
}

export function splitStega(value: string): { cleaned: string; encoded: string } {
  const encoded = value.match(STEGA_PATTERN)?.[0] ?? "";
  const cleaned = stegaClean(value);
  return { cleaned, encoded };
}
